import React from "react";
import {getCompoundEntityRef} from "@backstage/catalog-model";
import {makeStyles} from "@material-ui/core/styles";
import {TechDocsReaderPage} from "@backstage/plugin-techdocs";
import {TechDocsReaderPageContent} from "../../../../../core/TechDocs/TechDocsReaderPageContent";
import {useEntity} from "@backstage/plugin-catalog-react";
import {Grid} from "@material-ui/core";
import {WarningPanel} from "@backstage/core-components";
import {getPreviewBranchName, inPreviewMode} from "../../../../../../api/customTechDocsApi";

const useStyles = makeStyles({
  root: {
    marginBottom: '10px'
  }
})

const DocsContent = () => {
  const classes = useStyles();

  const {entity} = useEntity();
  let entityRef = getCompoundEntityRef(entity);

  return (
    <>
      <Grid>
        {inPreviewMode() && (
            <Grid item xs={12} className={classes.root}>
              <WarningPanel
                  defaultExpanded={false}
                  title="You are viewing preview documentation."
              >
                This is the <i>preview</i> documentation for the branch `<b>{getPreviewBranchName()}</b>` of this repository.
              </WarningPanel>
            </Grid>
        )}
      </Grid>
      <TechDocsReaderPage entityRef={entityRef}>
        <TechDocsReaderPageContent withSearch={false}/>
      </TechDocsReaderPage>
    </>
  )
}

export default DocsContent;
